import {PaymentMethodType} from 'components/manufacturer/Payments/entity/Setting';
import {camelizeKeys} from 'humps';
import {
    CardType,
    mapPaymentType,
    PaymentOptionsApiResponse as PaymentOptionsApiResponseInterface,
    PaymentOptions as PaymentOptionsInterface,
} from 'components/customer/Confirmation/Payment/entity/PaymentSession';
import {
    PaymentSettings,
    PaymentSettingsApiResponse,
} from 'components/customer/Confirmation/Payment/entity/Settings';

export interface PaymentSummary {
    jobId: number;
    fullAmount: number;
    paidGross: number;
    refunded: number;
    netPaid: number;
    balance: number;
    overpaidAmount: number;
    paymentDisplayStatus: string;
    paymentStatus: string;
    priceReduced: boolean;
    lastReceiptAt: {
        date: string;
        timezoneType: number;
        timezone: string;
    };
    initialJobTotal: number;
    paymentMethod: string;
}

export interface PaymentSummaryApiResponse {
    job_id: number;
    full_amount: number;
    paid_gross: number;
    refunded: number;
    net_paid: number;
    balance: number;
    overpaid_amount: number;
    payment_display_status: string;
    payment_status: string;
    price_reduced: boolean;
    last_receipt_at: {
        date: string;
        timezone_type: number;
        timezone: string;
    };
    initial_job_total: number;
    payment_method: string;
}

export interface PaymentOptions {
    allowPayOnAccount: boolean;
    currency: 'AUD' | 'NZL';
    defaultPaymentMethod: PaymentMethodType;
    fullAmount: number;
    jobId: number;
    paymentOptions: PaymentOptionsInterface;
    paymentSettings: PaymentSettings;
    defaultPaymentMethodType: CardType;
    paymentSummary: PaymentSummary;
}

export interface PaymentOptionsApiResponse {
    allow_pay_on_account: boolean;
    currency: 'AUD' | 'NZL';
    default_payment_method: PaymentMethodType;
    default_payment_method_type: CardType;
    full_amount: number;
    job_id: number;
    payment_options: PaymentOptionsApiResponseInterface;
    payment_settings: PaymentSettingsApiResponse;
    payment_summary: PaymentSummaryApiResponse;
}

export const mapToPaymentOptions = (
    rawPaymentOptions: PaymentOptionsApiResponse
) => {
    return camelizeKeys(mapPaymentType(rawPaymentOptions)) as PaymentOptions;
};
